import React, { useState } from 'react'
import Footer from './footer'
import Button from './input-components/button'
import ErrorLabel from './input-components/error-label'
import TextField from './input-components/textfield'
import Navbar from './navbar'
import { type CognitoUser } from '@aws-amplify/auth'
import { Auth } from 'aws-amplify'

interface NewPasswordRequiredProps {
  cognitoUser: CognitoUser | undefined
  onAuthChange: (authenticated: boolean) => void
}

const NewPasswordRequired = ({ cognitoUser, onAuthChange }: NewPasswordRequiredProps): JSX.Element => {
  const [isLoadingIndicator, setLoadingIndicator] = useState(false)
  const [password, setPassword] = useState('')
  const [passwordConfirmation, setPasswordConfirmation] = useState('')
  const [errorOccurred, setErrorHasOccurred] = useState(false)
  const [errorMessage, setErrorMessage] = useState('')

  const onClick = async (): Promise<void> => {
    try {
      setLoadingIndicator(true)
      setErrorHasOccurred(false)

      if (password !== passwordConfirmation) {
        setLoadingIndicator(false)
        setErrorHasOccurred(true)
        setErrorMessage('Passwords does not match! Please enter password again.')
      } else {
        await Auth.completeNewPassword(cognitoUser, password)
        onAuthChange(true)
        //#TODO: await router.push('/') // Route user to home page (this will only occur if the user is already logged in and the Auth won't trigger in the use-effect hook on the App page)
      }
    } catch (error : any) {
      setErrorHasOccurred(true);
      setErrorMessage(error.message);
    }

    setLoadingIndicator(false)
  }

  return (
        <div className="flex flex-col h-screen">
        <Navbar />
        <div className="md:container mx-auto justify-center items-center flex-1 flex w-3/4">
            <div className="w-full max-w-md space-y-4 ">
                {/* Add Sign In Label + Email Address + Password Text Fields. */}
                <div className="text-gray-600 flex justify-center items-center font-bold"> Create new password</div>
                <TextField id={'password'} type="password" placeholder={'Please enter new password'} setValue={setPassword}/>
                <TextField id={'passwordConfirm'} type="password" placeholder={'Please confirm password'} setValue={setPasswordConfirmation} />
                <Button id="changePassword" label="Submit" isLoading={isLoadingIndicator} onClick={onClick}></Button>
                <ErrorLabel id="errorLabel" label={errorMessage} isError={errorOccurred}></ErrorLabel>
            </div>
        </div>
        <Footer />
    </div>
  )
}

export default NewPasswordRequired
